// Un-Synced CubiCasa Orders — Redux action types
export const CUBICASA_UNSYNCED_LIST_REQUEST = "CUBICASA_UNSYNCED_LIST_REQUEST";
export const CUBICASA_UNSYNCED_LIST_SUCCESS = "CUBICASA_UNSYNCED_LIST_SUCCESS";
export const CUBICASA_UNSYNCED_LIST_FAILED = "CUBICASA_UNSYNCED_LIST_FAILED";

// Sync a CubiCasa order to a Nancy property/unit type (mark-synced)
export const CUBICASA_MARK_SYNCED_REQUEST = "CUBICASA_MARK_SYNCED_REQUEST";
export const CUBICASA_MARK_SYNCED_SUCCESS = "CUBICASA_MARK_SYNCED_SUCCESS";
export const CUBICASA_MARK_SYNCED_FAILED = "CUBICASA_MARK_SYNCED_FAILED";
export const CUBICASA_SYNC_RESET = "CUBICASA_SYNC_RESET";
